import React, { useState } from 'react';
import './ReferralPopup.css';

interface ReferralPopupProps {
  isOpen: boolean;
  onClose: () => void;
  refToken: string;
}

const ReferralPopup: React.FC<ReferralPopupProps> = ({ isOpen, onClose, refToken }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(refToken);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        onClose();
      }, 1000);
    } catch (err) {
      console.error('Failed to copy link:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = refToken;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        onClose();
      }, 1000);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="referral-popup-overlay" onClick={onClose}>
      <div className="referral-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="referral-popup-body">
          <h2 className="referral-title">
            🎁 Share & Earn Coins
          </h2>
          
          <p className="referral-description">
            Share your personal invitation link to invite your friends. When they join, <strong>both you and your friends will get free coins</strong> for classes and events!
          </p>

          <div className="referral-link-container">
            <span className="referral-link-text">
              {refToken}
            </span>
          </div>

          <div className="referral-buttons">
            <button 
              className={`referral-button copy-button ${copied ? 'copied' : ''}`}
              onClick={handleCopyLink}
            >
              {copied ? 'Copied!' : 'Copy the link'}
            </button>
            <button 
              className="referral-button cancel-button"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralPopup; 